const groupMobile = document.querySelector('.ys-global-header__inner');
const openBtn = groupMobile.querySelector('.yc-button-menu__item--open');
const closeBtn = groupMobile.querySelector('.yc-button-menu__item--close');
const mobileNav = groupMobile.querySelector('.yc-global-header-nav__container--mobile');

openBtn.addEventListener('click', () => {
  // groupMobile.classList.add('is-open');
  mobileNav.classList.add('is-open');
});

closeBtn.addEventListener('click', () => {
  // groupMobile.classList.remove('is-open');
  mobileNav.classList.remove('is-open');
});
